import { checkoutReviewAndSubmitActionButtonsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { productListStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList";
import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { creditCardBillingAddressEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.backButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                ],
                "max",
            )}
    `,
};

checkoutReviewAndSubmitHeaderStyles.placeOrderButton = {
    mergeCss: true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
};

checkoutReviewAndSubmitHeaderStyles.submitForApprovalButton = {
    mergeCss: true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
};

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0px 15px;
                    position: absolute;
                    left: 0;
                    bottom: -20;
                    width: 100%;
                    background: ${getColor("common.background")({ theme })};
                    justify-content: center;
                    z-index: ${get(theme, "zIndex.stickyFooter")};
                `,
                css`
                    margin-left: 16px;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};

promotionCodeFormStyles.applyButton = {
    mergeCss: true,
    variant: "primary",
    css: css`
        margin-top: 10px;
        &:disabled {
            border-color: ${COLORS.disabled.base} !important;
            background: ${COLORS.disabled.base} !important;
            color: ${COLORS.white} !important;
        }
    `,
};

productListStyles.orderLinesList = {
    wrapper: {
        css: css`
            div[class^="sc"] {
                h3 {
                    display: flex;
                    align-items: center;
                }
                h4 {
                    font-size: 16px !important;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        & > div:nth-child(1) {
                            & > div {
                                display: none;
                            }
                        }
                    `,
                    css`
                        & > div:nth-child(1) {
                            & > div {
                                display: none;
                            }
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

creditCardBillingAddressEntryStyles.useBillingAddressCheckbox = {
    css: css`
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

creditCardDetailsEntryStyles.saveCardCheckbox = {
    css: css`
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

checkoutReviewAndSubmitActionButtonsStyles.backButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                ],
                "max",
            )}
    `,
};

checkoutReviewAndSubmitActionButtonsStyles.placeOrderButton = {
    mergeCss: true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                ],
                "max",
            )}
    `,
};

checkoutReviewAndSubmitActionButtonsStyles.submitForApprovalButton = {
    mergeCss: true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                ],
                "max",
            )}
    `,
};
